import {FC, ChangeEvent, useState, useEffect} from "react";
import {useDebounce} from "use-debounce";
import {APP} from "../../Utils/Constants.ts";


interface TagsProps{
  handleTags: (filterId:string, value:string) => void;
  value: Filter|undefined;
}
const getDefaultValue = (value: Filter|undefined) => {
  if(value) {
    return typeof value.values == "string" ? value.values : value.values[0];
  }
  return ""
}
const Tags: FC<TagsProps> = ({ handleTags, value }) => {

  const [inputValue, setInputValue] = useState(getDefaultValue(value))
  const [debouncedValue] = useDebounce(inputValue, 500)

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if(event){
      setInputValue(event.target.value)
    }
  };

  useEffect(() => {
    if(value?.values == "" || value == undefined) {
      setInputValue("")
    }
  }, [value]);

  useEffect(() => {
    handleTags(APP.FILTER.SEARCH.FIELD, debouncedValue)
  }, [debouncedValue])

  return (
    <div className="filter-wrapper with-reset-button search-input">
      <label htmlFor="filter-tags" className="filter-label">{Drupal.t('Mots clés')}</label>
      <input id="filter-tags"
             className={"filter--tags"}
             placeholder={Drupal.t("Mots clés")}
        onChange={(value) => {handleInputChange(value)}}
        value={inputValue}
      />
    </div>
  );
}

export default Tags;
